import { ICON_SELECTOR, swapIcon } from '../helpers/w4d-icon.js';

(function ($) {
	const stockPendingMessage = 'Provjera zaliha nije dovršena. Pokušajte ponovno ili osvježite stranicu prije nastavka na blagajnu.';

	class W4D_Cart {
		constructor() {
			this.isClearing = false;
			this.cartRequestSeq = 0;
			this.cartAppliedSeq = 0;
			this.cartQuantityDrafts = new Map();
			this.cartMutationQueue = [];
			this.cartMutationActive = null;
			this.cartMutationUncertain = false;
			this.isProductTemplatePage = document.body.classList.contains('product-template-default');
			this.initSelectors();
			this.initCartQuantityState();
			this.bindEvents();
			this.setupCartUpdateListener();
			this.syncCartCountFromDom();

			this.currentVariationId = null;
			this.isShowingOriginal = true;
			this.relatedProductsXHR = false;

			this.initAddToCartTracking();
		}

		initAddToCartTracking() {
			// GTM4WP emits during document capture. Suppress its add_to_cart push for this native
			// dispatch; keep the actual click available to other native and delegated listeners.
			window.addEventListener(
				'click',
				(event) => {
					const button = event.target.closest?.('.w4d_add_to_cart_button');
					if (!button) return;
					this.nativeAddToCartClick = event;
					const push = window.gtm4wp_push_ecommerce;
					if (typeof push !== 'function' || push === this.nativeAddToCartPush) return;
					const cart = this;
					this.nativeAddToCartPush = function (name, ...args) {
						if (name === 'add_to_cart' && cart.nativeAddToCartClick?.eventPhase) return;
						return push.call(this, name, ...args);
					};
					window.gtm4wp_push_ecommerce = this.nativeAddToCartPush;
				},
				true
			);
		}

		collectAddToCartEvent(button, quantity, requestedId) {
			const track = button.classList.contains('single_add_to_cart_button')
				? window.gtm4wp_track_single_add_to_cart
				: window.gtm4wp_track_list_add_to_cart;
			if (typeof track !== 'function' || typeof window.gtm4wp_push_ecommerce !== 'function') return null;

			const originalPush = window.gtm4wp_push_ecommerce;
			let trackedEvent = null;
			try {
				// The helper is synchronous. Snapshot its metadata without publishing a click event.
				window.gtm4wp_push_ecommerce = (event, items, extra) => {
					if (event !== 'add_to_cart' || items.length !== 1) return originalPush(event, items, extra);
					const item = { ...items[0], quantity };
					trackedEvent = JSON.parse(
						JSON.stringify({ event, ecommerce: { ...extra, items: [item], value: Number((item.price * quantity).toFixed(2)) } })
					);
					// GTM4WP strips internal_id before emitting, so remember which product this snapshot is for.
					trackedEvent.internalId = requestedId;
				};
				track(button);
			} catch {
				// Analytics must never prevent an otherwise valid cart request.
				trackedEvent = null;
			} finally {
				window.gtm4wp_push_ecommerce = originalPush;
			}
			return trackedEvent;
		}

		pushCartEvents(data, trackedEvent = null) {
			const events = [...(data?.cart_events || [])];
			// SKUs may be inherited by several variations. Only enrich the confirmed add of the requested product.
			const index = trackedEvent?.internalId
				? events.findIndex(
						({ event, ecommerce }) =>
							event === 'add_to_cart' && String(ecommerce?.items?.[0]?.internal_id) === String(trackedEvent.internalId)
					)
				: -1;
			if (index > -1) {
				events[index] = {
					...events[index],
					ecommerce: {
						...trackedEvent.ecommerce,
						...events[index].ecommerce,
						items: [{ ...trackedEvent.ecommerce.items[0], ...events[index].ecommerce.items[0] }],
					},
				};
			}
			const layerName = window.gtm4wp_datalayer_name || 'dataLayer';
			window[layerName] = window[layerName] || [];
			events.forEach(({ event, ecommerce }) => {
				const { items, ...extra } = ecommerce;
				const publishedItems = items.map((item) => {
					const publishedItem = { ...item };
					delete publishedItem.internal_id;
					return publishedItem;
				});
				if (typeof window.gtm4wp_push_ecommerce === 'function') {
					window.gtm4wp_push_ecommerce(event, publishedItems, extra);
				} else {
					window[layerName].push({ ecommerce: null });
					window[layerName].push({ event, ecommerce: { ...extra, items: publishedItems } });
				}
			});
		}

		initSelectors() {
			this.$body = $('body');
			this.proceedButtonSelector = '.cart_totals .btn--action, .cart_totals .js-w4d-reservation';
			this.woocommerce = $('.woo-wrapper');
			this.cart = $('.cart').not('form');
			this.removeCartItem = '.js-remove-cart-item';
			this.cartCollaterals = $('.cart__collaterals');
			this.progressBar = $('.progress-bar');
			this.$addToCartButton = '.w4d_add_to_cart_button.single_add_to_cart_button';
			this.$sendInquiryContainer = '.product-sidebar__inquiry-container';
			this.availabilityBtn = '[data-js="availability-notify"]';

			// Cache core selectors used by variation flow
			this.$variationSelects = $('.variations select');
			this.$summaryDescription = $('#summary-description .accordion__content>div');
			this.$summaryProizvodjac = $('#summary-proizvodjac .accordion__content>div');
			this.variationPrice = '.single_variation_wrap .woocommerce-variation-price';
			this.variationQuantity = '.woocommerce-variation-quantity';
			this.priceWrapper = '.price-wrapper';
			this.$samoPregled_showPrice = $(this.variationPrice).attr('data-js-show-price');
			this.$headerCartIcon = $('#header_cart_icon');
			this.$sidebarInfo = $('.product-sidebar__info');
			this.availabilityLocationsTemplate = document.getElementById('availability-locations-template');
		}

		bindEvents() {
			this.$body.on('click', '.w4d_add_to_cart_button', (e) => this.handleAddToCart(e));
			this.$body.on('click', '#empty-cart-confirmation button[data-confirm="yes"]', () => this.handleRemoveCartAll());
			this.$body.on('click', '#share-cart', () => this.prepareShareCartUrl());
			this.$body.on('click', '#share-cart-copy-btn', (e) => this.copyShareCartUrl(e));

			$(document).on('click', this.removeCartItem, (e) => this.handleRemoveCartItem($(e.currentTarget)));
			$(document).on('change', '.variations select', (e) => this.handleVariationChange(e));
			$(document).on('change', '.variations__input[type="radio"]', (e) => this.handleAdvancedVariationChange(e));
			this.$body.on('found_variation', '.variations_form', (event, variation) => {
				this.updateStockStatus(variation);
			});
			this.$body.on('reset_data', '.variations_form', () => {
				this.resetStockStatus();
			});
			// Only the checkout button navigates; proceedButtonSelector also covers "Rezerviraj" (enabled and disabled together).
			$(document).on('click', '.cart_totals .btn--action', (e) => this.handleProceedToCheckout(e));
			this.$body.on('click', '#reservation-confirmation button[data-confirm="yes"]', () => this.handleReservation());
			// Disabled buttons still receive pointerdown; let a checkout or reservation attempt finish the current edit.
			$(document).on('pointerdown', this.proceedButtonSelector, () => this.blurCartQuantityInput());
			$(document).on('change', '.cart__item .product-quantity__number[data-location="cart"]', (e) => {
				this.noteCartQuantityEdit($(e.target));
			});
			$(document).on('click', '[data-toggle-summary]', (e) => this.handleSummaryToggle(e));

			if (this.isProductTemplatePage && $('.variations_container').length) {
				this.handleVariationChange();
				// If handleVariationChange found a matching variation, isShowingOriginal will be false.
				// If it didn't find a match, it will be true.
			}
		}

		handleSummaryToggle(e) {
			const $button = $(e.currentTarget);
			const $summary = $button.closest('.cart_totals').find('.cart__summary');
			const isExpanded = $button.attr('aria-expanded') === 'true';

			if (isExpanded) {
				$summary.attr('data-summary-collapsed', '');
				$button.attr('aria-expanded', 'false');
			} else {
				$summary.removeAttr('data-summary-collapsed');
				$button.attr('aria-expanded', 'true');
			}
		}

		syncCartCountFromDom() {
			const cartCount = parseInt(this.$headerCartIcon.attr('data-populated') || '0', 10);
			localStorage.setItem('w4d_cart_count', cartCount);
		}

		handleProceedToCheckout(e) {
			e.preventDefault();
			if (this.hasPendingCartChanges() || this.hasCartQuantityErrors()) {
				this.blurCartQuantityInput();
				this.enableProceedButton();
				return;
			}
			window.location.href = $(e.currentTarget).data('href');
		}

		handleReservation() {
			if (this.isReserving) {
				return;
			}

			// Like checkout: never reserve while a quantity change is unsaved or the cart has a blocking quantity error.
			if (this.hasPendingCartChanges() || this.hasCartQuantityErrors()) {
				this.blurCartQuantityInput();
				this.enableProceedButton();
				W4D_Toast.showToast('error', 'Pričekajte da se promjena količine spremi ili ispravite količinu, pa pokušajte ponovno.');
				return;
			}

			this.isReserving = true;
			// Restore only controls this reservation disabled; keep any existing quantity restrictions.
			this.$reservationQuantityControls = this.cart
				.find('.product-quantity__number, button[data-js-stepper]')
				.filter(':enabled')
				.prop('disabled', true);

			$.ajax({
				type: 'POST',
				url: w4d_frontend_ajax.ajax_url,
				data: {
					action: 'w4d_create_reservation',
					nonce: w4d_frontend_ajax.nonce,
				},
				beforeSend: () => {
					this.disableProceedButton();
					this.cart.addClass('cart--loading');
					this.cartCollaterals.addClass('cart__collaterals--loading');
				},
				success: (response) => {
					if (response.success && response.data?.redirect) {
						window.location.href = response.data.redirect;
						return;
					}

					this.reservationFailed(response.data?.message);
				},
				error: (xhr) => {
					this.reservationFailed(xhr.responseJSON?.data?.message);
				},
			});
		}

		reservationFailed(message) {
			this.isReserving = false;
			this.$reservationQuantityControls.prop('disabled', false);
			this.enableProceedButton();
			this.cart.removeClass('cart--loading');
			this.cartCollaterals.removeClass('cart__collaterals--loading');
			W4D_Toast.showToast('error', message || 'Rezervaciju nije moguće kreirati. Pokušajte ponovno.');
			this.runNextCartMutation();
		}

		blurCartQuantityInput() {
			const input = document.activeElement;
			if ($(input).is('.cart__item .product-quantity__number[data-location="cart"]')) input.blur();
		}

		disableProceedButton() {
			const $proceedButton = $(this.proceedButtonSelector);
			if ($proceedButton.length) {
				$proceedButton.prop('disabled', true);
			}
		}

		enableProceedButton() {
			const $proceedButton = $(this.proceedButtonSelector);
			if ($proceedButton.length) {
				const disabled = this.isReserving || this.hasPendingCartChanges() || this.hasCartQuantityErrors();
				$proceedButton.prop('disabled', Boolean(disabled));
			}
		}

		setupCartUpdateListener() {
			this.$body.on('updated_cart_totals wc_cart_emptied', (e) => {
				const itemCount = e.type === 'wc_cart_emptied' ? 0 : $('.cart__item').length;
				W4D_FrontendHelper.updateCartIcon(itemCount);
			});
		}

		updateCartNotices(html, quantityState, $updatedRow) {
			if (typeof html === 'string') {
				$('.woocommerce-notices-wrapper').first().html(html);
			}
			this.applyCartQuantityState(quantityState, $updatedRow);
		}

		getCartRoot() {
			return $('.woocommerce-notices-wrapper').first().closest('.woocommerce');
		}

		initCartQuantityState() {
			this.getCartRoot()
				.find('.cart__item-quantity')
				.each((index, element) => {
					const $quantity = $(element);
					const state = $quantity.data('quantity-state');
					if (state && typeof state.quantity === 'number') {
						$quantity.closest('.cart__item').data('server-quantity', state.quantity);
					}
					const $row = $quantity.closest('.cart__item');
					const draft = this.getCartQuantityDraft($row);
					draft.unvalidated = state?.validated === false;
					if (draft.unvalidated && !state.error) {
						this.setCartQuantityMessage(
							this.getCartQuantityFeedback($quantity).find('.cart__quantity-message'),
							stockPendingMessage,
							false
						);
					}
					this.updateCartQuantityAnnouncement($row);
					this.updateCartQuantityAria($quantity);
				});
			this.enableProceedButton();
		}

		hasCartQuantityErrors() {
			return this.getCartRoot().find('[data-quantity-blocking="true"], [data-quantity-range-invalid="true"]').length > 0;
		}

		getCartBaseInput($row) {
			const $base = $row.find('.product-quantity__number.js-jm1').first();
			return $base.length ? $base : $row.find('.product-quantity__number').first();
		}

		getCartInputQuantity($input) {
			const value = parseFloat(String($input.val() || '').replace(',', '.'));
			const factor = $input.hasClass('js-jm2') ? parseFloat($input.data('faktor')) || 1 : 1;
			return Number.isFinite(value) ? W4D_ProductQuantityHelper.roundToDecimalPlaces(value / factor, 6) : null;
		}

		getCartQuantityDraft($row) {
			let draft = this.cartQuantityDrafts.get($row[0]);
			if (!draft) {
				const $input = this.getCartBaseInput($row);
				const quantity = $input.length ? this.getCartInputQuantity($input) : ($row.data('server-quantity') ?? null);
				if (typeof $row.data('server-quantity') !== 'number') $row.data('server-quantity', quantity);
				draft = { quantity, revision: 0, timer: null, unvalidated: false };
				this.cartQuantityDrafts.set($row[0], draft);
			}
			return draft;
		}

		noteCartQuantityEdit($input) {
			const $row = $input.closest('.cart__item');
			if (!$row.length) return;
			const draft = this.getCartQuantityDraft($row);
			const quantity = this.getCartInputQuantity($input);
			if (draft.quantity !== quantity) {
				draft.quantity = quantity;
				draft.revision++;
				// A queued blur belongs to its draft. A newer edit waits for its own blur.
				this.cartMutationQueue = this.cartMutationQueue.filter(
					(operation) => operation.type !== 'quantity' || !operation.$row.is($row)
				);
			}
			if (quantity === $row.data('server-quantity') && !this.cartMutationActive?.$row?.is($row)) {
				clearTimeout(draft.timer);
				draft.timer = null;
				this.clearAutoQuantityRangeWarning($input.closest('.product-quantity'));
			}
			this.enableProceedButton();
		}

		hasPendingCartChanges() {
			if (this.cartMutationUncertain || this.cartMutationActive || this.cartMutationQueue.length) return true;
			for (const [element, draft] of this.cartQuantityDrafts) {
				if (element.isConnected && (draft.timer || draft.unvalidated || draft.quantity !== $(element).data('server-quantity')))
					return true;
			}
			return false;
		}

		scheduleCartQuantityUpdate($input) {
			const $row = $input.closest('.cart__item');
			const draft = this.getCartQuantityDraft($row);
			clearTimeout(draft.timer);
			// Preserve the existing dual-unit rounding, without the non-cart shared timeout.
			W4D_ProductQuantity.handleSidebarQuantityUpdate($input[0]);
			this.noteCartQuantityEdit(this.getCartBaseInput($row));
			if (!draft.unvalidated && draft.quantity === $row.data('server-quantity') && !this.cartMutationActive?.$row?.is($row)) {
				draft.timer = null;
				this.enableProceedButton();
				return;
			}
			draft.timer = setTimeout(() => {
				draft.timer = null;
				const active = document.activeElement;
				if ($row.has(active).length && $(active).hasClass('product-quantity__number')) {
					this.enableProceedButton();
					return;
				}
				this.handleUpdateCartOnCartPage(this.getCartBaseInput($row));
			}, 300);
			this.enableProceedButton();
		}

		queueCartMutation(operation) {
			if (operation.$row) {
				const draft = this.getCartQuantityDraft(operation.$row);
				clearTimeout(draft.timer);
				draft.timer = null;
				this.cartMutationQueue = this.cartMutationQueue.filter((queued) => !queued.$row?.is(operation.$row));
			}
			this.cartMutationQueue.push(operation);
			this.enableProceedButton();
			this.runNextCartMutation();
		}

		runNextCartMutation() {
			if (this.isReserving || this.cartMutationActive || this.cartMutationUncertain) return;
			const operation = this.cartMutationQueue.shift();
			if (!operation) {
				this.restoreCartUpdateState();
				this.enableProceedButton();
				return;
			}
			if (operation.$row && (!operation.$row[0].isConnected || operation.$row.data('cart-removed'))) {
				this.runNextCartMutation();
				return;
			}
			this.cartMutationActive = operation;
			this.cart.addClass('cart--loading');
			this.cartCollaterals.addClass('cart__collaterals--loading');
			this.disableProceedButton();
			if (operation.type === 'quantity') this.sendCartQuantityUpdate(operation);
			else if (operation.type === 'remove') this.sendCartItemRemoval(operation);
			else if (operation.type === 'coupon') operation.send(operation);
			else this.sendCartEmpty(operation);
		}

		finishCartMutation(operation) {
			if (this.cartMutationActive !== operation) return;
			operation.$row?.removeClass('cart__item--removing removing');
			this.cartMutationActive = null;
			this.restoreCartUpdateState();
			this.enableProceedButton();
			this.runNextCartMutation();
		}

		markCartMutationUncertain(message = 'Nije moguće potvrditi promjene košarice. Osvježite stranicu prije nastavka na blagajnu.') {
			// A lost response may still have committed. Only a reload can establish the saved cart again.
			this.cartMutationUncertain = true;
			W4D_Toast.showToast('error', message);
			this.enableProceedButton();
		}

		applyCartQuantityState(state, $updatedRow) {
			if (!state || !state.items) return;
			this.getCartRoot()
				.find('.cart__item-quantity')
				.each((index, element) => {
					const $quantity = $(element);
					const item = state.items[$quantity.attr('data-cart-item-key')];
					if (!item) return;
					const $row = $quantity.closest('.cart__item');
					$row.data('server-quantity', item.quantity);
					// The plugin reserves validated:false for checks that are required to proceed.
					this.getCartQuantityDraft($row).unvalidated = item.validated === false;
					if (item.step > 0) {
						$quantity.find('.product-quantity__number').each((i, input) => {
							const $input = $(input);
							const factor = $input.hasClass('js-jm2') ? parseFloat($input.data('faktor')) || 1 : 1;
							$input
								.attr('step', item.step * factor)
								.closest('.product-quantity')
								.attr('data-step', item.step * factor);
						});
					}
					if ($updatedRow && $row.is($updatedRow)) {
						this.restoreSavedCartQuantity($row, item.quantity);
					}
					// Always replace stale stock errors with the current saved-cart snapshot.
					$quantity.attr('data-quantity-invalid', item.error ? 'true' : null);
					$quantity.attr('data-quantity-blocking', item.blocking ? 'true' : null);
					this.setCartQuantityMessage(
						this.getCartQuantityFeedback($quantity).find('.cart__quantity-message'),
						item.error ? item.error.message : item.validated === false ? stockPendingMessage : '',
						Boolean($updatedRow && $row.is($updatedRow))
					);
					this.updateCartQuantityAria($quantity);
				});
			this.enableProceedButton();
		}

		setCartQuantityMessage($message, message, repeat = true) {
			const $text = $message.find('.cart__quantity-message-text');
			($text.length ? $text : $message).text(message);
			$message.prop('hidden', !message);
			this.updateCartQuantityAnnouncement($message.closest('.cart__item'), repeat);
		}

		updateCartQuantityAnnouncement($row, repeat = false) {
			// The announcer stays in the accessibility tree even when the visual badges are hidden.
			const text = $row
				.find('.cart__quantity-feedback .cart__quantity-message-text')
				.map((index, element) => $(element).text())
				.get()
				.filter(Boolean)
				.join(' ');
			const $announcer = $row.find('.cart__quantity-announcement');
			clearTimeout($row.data('quantity-announcement-timer'));
			if (repeat && text) {
				// A separate DOM update lets assistive technology announce identical rejections again.
				$announcer.text('');
				$row.data(
					'quantity-announcement-timer',
					setTimeout(() => $announcer.text(text), 100)
				);
			} else if ($announcer.text() !== text) {
				$announcer.text(text);
			}
		}

		getCartQuantityFeedback($quantity) {
			const $feedback = $quantity.closest('.cart__item').find('.cart__quantity-feedback');
			return $feedback.length ? $feedback : $quantity;
		}

		restoreSavedCartQuantity($row, quantity = $row.data('server-quantity')) {
			if (typeof quantity !== 'number') return;
			this.getCartQuantityDraft($row).quantity = quantity;
			$row.find('.product-quantity__number').each((index, element) => {
				const $input = $(element);
				const factor = $input.hasClass('js-jm2') ? parseFloat($input.data('faktor')) || 1 : 1;
				const value = W4D_ProductQuantityHelper.roundToDecimalPlaces(quantity * factor, 6);
				const display = String(value).replace('.', ',');
				$input
					.val(display)
					.attr('value', value)
					.attr('data-quantity', value)
					.data('quantity', value)
					.data('starting-value', display);
			});
		}

		updateCartQuantityAria($quantity) {
			const stockInvalid = $quantity.attr('data-quantity-invalid') === 'true';
			const rangeInvalid = $quantity.attr('data-quantity-range-invalid') === 'true';
			const $feedback = this.getCartQuantityFeedback($quantity);
			const messageId = $feedback.find('.cart__quantity-message').attr('id');
			const rangeId = $feedback.find('.cart__quantity-range-message').attr('id');
			$quantity.find('.product-quantity__number').each((index, element) => {
				const $input = $(element);
				const ids = ($input.attr('aria-describedby') || '').split(/\s+/).filter((id) => id && id !== messageId && id !== rangeId);
				if (stockInvalid && messageId) ids.push(messageId);
				if (rangeInvalid && rangeId) ids.push(rangeId);
				$input.attr('aria-invalid', stockInvalid || rangeInvalid ? 'true' : null);
				$input.attr('aria-describedby', ids.length ? ids.join(' ') : null);
			});
		}

		// Keep response guards as well as serial requests: saved cart state and newer drafts are separate.
		beginCartRequest($row) {
			const requestId = ++this.cartRequestSeq;
			if ($row) $row.data('cart-request', requestId);
			return requestId;
		}

		// Cart-wide data (notices, quantity state, summary, totals) is applied only if no later request already was.
		acceptCartResponse(requestId) {
			if (requestId < this.cartAppliedSeq) return false;
			this.cartAppliedSeq = requestId;
			return true;
		}

		isLatestCartRequest(requestId) {
			return requestId === this.cartRequestSeq;
		}

		isLatestRowRequest($row, requestId) {
			return $row.data('cart-request') === requestId;
		}

		handleRemoveCartAll() {
			for (const draft of this.cartQuantityDrafts.values()) {
				clearTimeout(draft.timer);
				draft.timer = null;
			}
			this.cartMutationQueue = [];
			this.queueCartMutation({ type: 'empty' });
		}

		sendCartEmpty(operation) {
			let $cartContainer = $('.cart').closest('.woocommerce');
			const requestId = this.beginCartRequest();

			$.ajax({
				type: 'POST',
				url: wc_add_to_cart_params.ajax_url,
				data: {
					action: 'w4d_empty_cart',
					nonce: w4d_frontend_ajax.nonce,
				},
				beforeSend: () => {
					this.cart.addClass('cart--loading');
					this.cartCollaterals.addClass('cart__collaterals--loading');
				},
				success: (response) => {
					if (!response?.data?.cart_quantity_state?.items) {
						this.markCartMutationUncertain();
						return;
					}
					if (response.success) {
						W4D_Toast.showToast('success', 'Košarica ispražnjena.');
						if (!this.acceptCartResponse(requestId)) return;
						window.W4D_Meter?.updateMeterAfterCartChange(response.data.free_shipping_progress);
						W4D_FrontendHelper.updateCartIcon(response.data.cart_count);
						// Provjeri postoji li data-summary-collapsed atribut prije zamjene
						const $cartSummary = $('.cart__summary');
						const wasCollapsed = $cartSummary.attr('data-summary-collapsed') !== undefined;

						if (response.data.cart_summary) {
							let newSummaryHtml = response.data.cart_summary;

							// Ako PRET postojanja atributa, ukloni ga iz novog HTML-a
							if (!wasCollapsed) {
								// Ukloni cijeli data-summary-collapsed atribut iz HTML stringa
								newSummaryHtml = newSummaryHtml.replace(
									/data-summary-collapsed(?:\s*=\s*(?:["'][^"']*["']|[^>\s]*))?/gi,
									''
								);
							}

							// Zamijeni element s modificiranim HTML-om
							$cartSummary.replaceWith(newSummaryHtml);
						}
						if (response.data.cart_empty_html) {
							this.handleCartEmptyState(response.data.cart_empty_html, $cartContainer);
						}
						this.updateCartNotices(response.data.cart_notices, response.data.cart_quantity_state);
					} else {
						this.updateCartNotices(response.data.cart_notices, response.data.cart_quantity_state);
						W4D_Toast.showToast('error', response.data.message || 'Nije moguće isprazniti košaricu.');
					}
				},
				complete: () => {
					this.finishCartMutation(operation);
				},
				error: (xhr, status, error) => {
					console.error('Greška u pozivu:', error);
					this.markCartMutationUncertain();
				},
			});
		}

		handleRemoveCartItem($item) {
			const $row = $item.closest('.cart__item');
			if (!$row.length || (this.cartMutationActive?.type === 'remove' && this.cartMutationActive.$row.is($row))) return;
			this.queueCartMutation({ type: 'remove', $row, revision: this.getCartQuantityDraft($row).revision });
		}

		sendCartItemRemoval(operation) {
			const $cartRow = operation.$row;
			const $baseInput = this.getCartBaseInput($cartRow);
			const $remove = $cartRow.find('.js-remove-cart-item').first();
			const $item = $baseInput.length ? $baseInput : $remove;
			const productId = $item.data('product-id') || $remove.data('product-id');
			const variationId = $item.data('variation-id') ?? $remove.data('variation-id') ?? 0;
			const cartItemKey = $cartRow.find('.cart__item-quantity').attr('data-cart-item-key') || $item.data('cart-item-key');
			const productName = $cartRow.find('.cart__item-name a').text();
			const $cartContainer = $('.cart').closest('.woocommerce');

			const ajaxData = {
				action: 'w4d_add_to_cart',
				cart_item_key: cartItemKey,
				product_id: productId,
				variation_id: variationId,
				quantity: 0,
				update_cart: true,
				return_cart_data: true,
				nonce: w4d_frontend_ajax.nonce,
			};

			$cartRow.addClass('removing');
			const requestId = this.beginCartRequest($cartRow);

			$.post({
				url: w4d_frontend_ajax.ajax_url,
				data: ajaxData,
				beforeSend: () => {
					this.cart.addClass('cart--loading');
					this.cartCollaterals.addClass('cart__collaterals--loading');
					$cartRow.addClass('cart__item--removing');
					this.disableProceedButton();
				},
				success: (response) => {
					if (!response?.data?.cart_quantity_state?.items) {
						this.markCartMutationUncertain();
						return;
					}
					if (response.success) {
						this.pushCartEvents(response.data);
						$cartRow.data('cart-removed', true);
						$cartRow.slideUp(300, () => {
							this.cartQuantityDrafts.delete($cartRow[0]);
							$cartRow.remove();
							this.enableProceedButton();
						});
						W4D_Toast.showToast('success', `${productName} uklonjen`);
						if (!this.acceptCartResponse(requestId)) return;
						window.W4D_Meter?.updateMeterAfterCartChange(response.data.free_shipping_progress);
						W4D_FrontendHelper.updateCartIcon(response.data.cart_count);

						// Provjeri postoji li data-summary-collapsed atribut prije zamjene
						const $cartSummary = $('.cart__summary');
						const wasCollapsed = $cartSummary.attr('data-summary-collapsed') !== undefined;

						if (response.data.cart_summary) {
							let newSummaryHtml = response.data.cart_summary;

							// Ako PRET postojanja atributa, ukloni ga iz novog HTML-a
							if (!wasCollapsed) {
								// Ukloni cijeli data-summary-collapsed atribut iz HTML stringa
								newSummaryHtml = newSummaryHtml.replace(
									/data-summary-collapsed(?:\s*=\s*(?:["'][^"']*["']|[^>\s]*))?/gi,
									''
								);
							}

							// Zamijeni element s modificiranim HTML-om
							$cartSummary.replaceWith(newSummaryHtml);
						}

						if (response.data.cart_empty_html) {
							this.handleCartEmptyState(response.data.cart_empty_html, $cartContainer);
						}
						this.updateCartNotices(response.data.cart_notices, response.data.cart_quantity_state);
					} else {
						// Always report the failed removal; only cart-wide data is skipped when a later response was applied.
						W4D_Toast.showToast('error', response.data.message || 'Nije moguće ukloniti artikl.');
						if (!this.acceptCartResponse(requestId)) return;
						const latestDraft = operation.revision === this.getCartQuantityDraft($cartRow).revision;
						this.updateCartNotices(
							response.data.cart_notices,
							response.data.cart_quantity_state,
							latestDraft ? $cartRow : undefined
						);
						this.updateRejectedCartTotals($cartRow, response.data);
					}
				},
				complete: () => {
					this.finishCartMutation(operation);
				},
				error: () => this.markCartMutationUncertain(),
			});
		}

		handleCartEmptyState(html, element) {
			element.empty().html(html);
			$('.woo-wrapper__sidebar').remove();
		}

		handleUpdateCartOnCartPage(input) {
			let $input = $(input);
			const $cartRow = $input.closest('.cart__item');
			if (!$cartRow.length || !$cartRow[0].isConnected) return;
			W4D_ProductQuantity.handleSidebarQuantityUpdate($input[0]);
			$input = this.getCartBaseInput($cartRow);
			const inputValue = parseFloat($input.val().replace(',', '.')) || 0;
			const $step = parseFloat($input.attr('step')) || 1;
			const $step_decimal_places = W4D_ProductQuantityHelper.getDecimalPlaces($step);
			const remainder = inputValue % $step;
			let roundedValue;

			if (remainder > 0.0000001) {
				roundedValue = W4D_ProductQuantityHelper.roundToDecimalPlaces(Math.ceil(inputValue / $step) * $step, $step_decimal_places);
			} else {
				roundedValue = inputValue;
			}

			const displayValue = String(roundedValue).replace('.', ',');

			$input
				.val(displayValue)
				.attr('value', roundedValue)
				.attr('data-quantity', roundedValue)
				.data('quantity', roundedValue)
				.trigger('change');
			this.noteCartQuantityEdit($input);
			const draft = this.getCartQuantityDraft($cartRow);
			if (roundedValue === 0) {
				this.handleRemoveCartItem($input);
				return;
			}
			if (!draft.unvalidated && roundedValue === $cartRow.data('server-quantity') && !this.cartMutationActive?.$row?.is($cartRow)) {
				this.enableProceedButton();
				return;
			}
			this.queueCartMutation({ type: 'quantity', $row: $cartRow, quantity: roundedValue, revision: draft.revision });
		}

		sendCartQuantityUpdate(operation) {
			const $cartRow = operation.$row;
			const $input = this.getCartBaseInput($cartRow);
			const roundedValue = operation.quantity;
			const draft = this.getCartQuantityDraft($cartRow);
			if (operation.revision !== draft.revision || (!draft.unvalidated && roundedValue === $cartRow.data('server-quantity'))) {
				this.finishCartMutation(operation);
				return;
			}

			// Auto quantity variation selection (cart support): resolve the matching variation
			// for the entered quantity before updating the cart.
			const $productQuantity = $input.closest('.product-quantity');
			const autoQuantityEnabled = $productQuantity.attr('data-js-auto-quantity-variation-selection') === '1';
			let targetVariationId = $input.data('variation-id');
			let oldVariationId = 0;

			if (autoQuantityEnabled) {
				const resolution = this.resolveAutoQuantityCartVariation($productQuantity, $input, roundedValue);

				if (!resolution.valid) {
					// Quantity is outside any available range: never auto-select the nearest option.
					this.setAutoQuantityRangeWarning($productQuantity, resolution.maxValue);
					this.disableProceedButton();
					this.finishCartMutation(operation);
					return;
				}

				this.clearAutoQuantityRangeWarning($productQuantity);
				oldVariationId = parseInt($input.data('variation-id'), 10) || 0;
				targetVariationId = resolution.variationId;
			}

			const ajaxData = {
				action: 'w4d_add_to_cart',
				update_cart: true,
				return_cart_data: true,
				cart_item_key: $cartRow.find('.cart__item-quantity').attr('data-cart-item-key') || $input.data('cart-item-key'),
				product_id: $input.data('product-id'),
				variation_id: targetVariationId,
				quantity: roundedValue,
				nonce: w4d_frontend_ajax.nonce,
			};

			// Only request a variation swap when the matched variation actually differs.
			if (autoQuantityEnabled && oldVariationId && oldVariationId !== targetVariationId) {
				ajaxData.old_variation_id = oldVariationId;
			}

			const requestId = this.beginCartRequest($cartRow);

			$.post({
				url: w4d_frontend_ajax.ajax_url,
				data: ajaxData,
				beforeSend: () => {
					$cartRow.addClass('cart__item--removing');
				},
				success: (response) => {
					const savedKey = response?.data?.cart_item_key || $cartRow.find('.cart__item-quantity').attr('data-cart-item-key');
					const savedItem = response?.data?.cart_quantity_state?.items?.[savedKey];
					if (!Number.isFinite(savedItem?.quantity)) {
						this.markCartMutationUncertain();
						return;
					}
					// Row-local results belong to the row's newest request; cart-wide ones to the newest applied response.
					const latestRow =
						this.isLatestRowRequest($cartRow, requestId) && operation.revision === this.getCartQuantityDraft($cartRow).revision;
					if (response.success) {
						this.pushCartEvents(response.data);

						// If the variation was switched, keep the cart row's data attributes in sync
						// with the newly added variation/cart item key for subsequent updates and removal.
						if (response.data.variation_switched) {
							this.reconcileCartVariationMerge($cartRow, response.data, operation);
							this.syncCartRowAfterVariationSwitch($cartRow, $input, response.data);
						}

						// Subtotals describe saved state, even if the shopper has typed a newer draft.
						if (this.isLatestRowRequest($cartRow, requestId)) {
							const totalElement = $cartRow.find('.cart__item-subtotal');
							if (totalElement.length) {
								totalElement.html(response.data.item_total);
							}
						}

						if (!this.acceptCartResponse(requestId)) return;

						W4D_FrontendHelper.updateCartIcon(response.data.cart_count);
						if (response.data.cart_empty_html) {
							this.handleCartEmptyState(response.data.cart_empty_html, $cartRow.closest('.woocommerce'));
						}
						this.updateCartNotices(
							response.data.cart_notices,
							response.data.cart_quantity_state,
							latestRow ? $cartRow : undefined
						);
						if (Object.values(response.data.cart_quantity_state.items).some((item) => item.validated === false)) {
							W4D_Toast.showToast('error', stockPendingMessage);
						} else if (
							!this.cartMutationUncertain &&
							!response.data.cart_quantity_state?.blocking &&
							!this.hasCartQuantityErrors()
						) {
							W4D_Toast.showToast('success', 'Košarica je uspješno ažurirana');
						}

						// Provjeri postoji li data-summary-collapsed atribut prije zamjene
						const $cartSummary = $('.cart__summary');
						const wasCollapsed = $cartSummary.attr('data-summary-collapsed') !== undefined;

						if (response.data.cart_summary) {
							let newSummaryHtml = response.data.cart_summary;

							// Ako PRET postojanja atributa, ukloni ga iz novog HTML-a
							if (!wasCollapsed) {
								// Ukloni cijeli data-summary-collapsed atribut iz HTML stringa
								newSummaryHtml = newSummaryHtml.replace(
									/data-summary-collapsed(?:\s*=\s*(?:["'][^"']*["']|[^>\s]*))?/gi,
									''
								);
							}

							// Zamijeni element s modificiranim HTML-om
							$cartSummary.replaceWith(newSummaryHtml);
						}

						window.W4D_Meter?.updateMeterAfterCartChange(response.data.free_shipping_progress);
					} else {
						if (latestRow) {
							this.restoreSavedCartQuantity($cartRow);
						}
						const accepted = this.acceptCartResponse(requestId);
						if (accepted) {
							this.updateCartNotices(
								response.data?.cart_notices,
								response.data?.cart_quantity_state,
								latestRow ? $cartRow : undefined
							);
							this.updateRejectedCartTotals($cartRow, response.data);
						}
						if (!accepted || !$cartRow.find('[data-quantity-invalid="true"]').length) {
							W4D_Toast.showToast('error', response.data?.message || 'Nije moguće spremiti odabranu količinu.');
						}
					}
				},
				complete: () => {
					this.finishCartMutation(operation);
				},
				error: () => {
					this.markCartMutationUncertain();
				},
			});
		}

		updateRejectedCartTotals($row, data) {
			if (data?.item_total !== undefined) $row.find('.cart__item-subtotal').html(data.item_total);
			if (data?.cart_summary) {
				const $summary = $('.cart__summary');
				const collapsed = $summary.attr('data-summary-collapsed') !== undefined;
				const $replacement = $(data.cart_summary);
				if (!collapsed) $replacement.removeAttr('data-summary-collapsed');
				$summary.replaceWith($replacement);
			}
			window.W4D_Meter?.updateMeterAfterCartChange(data?.free_shipping_progress);
		}

		// >---------------------------------- AUTO QUANTITY VARIATION SELECTION (CART) ----------------------------------<

		// Reserved quantity variation attribute.
		// Nort requested that pa_kolicina is used as an internal quantity-range selector.
		// For now this is intentionally hardcoded because the feature is client-specific.
		// If this behavior needs to support more clients/attributes later, this should be moved
		// to a configurable setting or exposed through a data attribute.
		getAutoQuantityCartAttributeKey() {
			return 'attribute_pa_kolicina';
		}

		// Parse a single pa_kolicina option value into a numeric range.
		// Supports exact ("1"), interval ("4-10", "4 - 10") and open-ended ("11+", "11 +") formats.
		parseAutoQuantityOption(rawValue) {
			if (rawValue === undefined || rawValue === null) {
				return null;
			}

			const value = String(rawValue).trim();

			if (/^\d+$/.test(value)) {
				const n = parseInt(value, 10);
				return { raw: rawValue, min: n, max: n };
			}

			const plusMatch = value.match(/^(\d+)\s*\+$/);
			if (plusMatch) {
				const n = parseInt(plusMatch[1], 10);
				return { raw: rawValue, min: n, max: Infinity };
			}

			const rangeMatch = value.match(/^(\d+)\s*-\s*(\d+)$/);
			if (rangeMatch) {
				const min = parseInt(rangeMatch[1], 10);
				const max = parseInt(rangeMatch[2], 10);
				if (min <= max) {
					return { raw: rawValue, min, max };
				}
			}

			return null;
		}

		findAutoQuantityRangeMatch(quantity, ranges) {
			// First match in variation/data order wins (overlaps resolved by order, no nearest fallback).
			for (const range of ranges) {
				if (quantity >= range.min && quantity <= range.max) {
					return range;
				}
			}
			return null;
		}

		// Resolve the cart item's matching variation for the entered quantity.
		// Returns { valid: false } when the quantity falls outside every available range,
		// otherwise { valid: true, variationId } preserving all non-quantity attributes (e.g. pa_trajanje).
		resolveAutoQuantityCartVariation($productQuantity, $input, quantity) {
			const variations = $productQuantity.data('product_variations');
			const attributeKey = this.getAutoQuantityCartAttributeKey();

			if (!Array.isArray(variations) || !variations.length) {
				// Nothing to resolve against; keep the existing variation.
				return { valid: true, variationId: $input.data('variation-id') };
			}

			// Build the available ranges in variation/data order (used for overlap resolution).
			const ranges = [];
			const seen = {};
			variations.forEach((variation) => {
				const raw = variation.attributes ? variation.attributes[attributeKey] : undefined;
				if (raw === undefined || raw === '') {
					return;
				}
				if (seen[raw]) {
					return;
				}
				seen[raw] = true;
				const parsed = this.parseAutoQuantityOption(raw);
				if (parsed) {
					ranges.push(parsed);
				}
			});

			const match = this.findAutoQuantityRangeMatch(quantity, ranges);
			if (!match) {
				return { valid: false, maxValue: this.getAutoQuantityMaxValue(ranges) };
			}

			// Preserve the current variation's non-quantity attributes (e.g. pa_trajanje).
			const currentVariationId = parseInt($input.data('variation-id'), 10) || 0;
			const currentVariation = variations.find((v) => v.variation_id === currentVariationId);
			const currentAttributes = currentVariation && currentVariation.attributes ? currentVariation.attributes : {};

			const target = variations.find((variation) => {
				const attributes = variation.attributes || {};
				return Object.keys(attributes).every((attr) => {
					const variationValue = attributes[attr];

					// Empty value acts as a wildcard in WooCommerce variation data.
					if (variationValue === '') {
						return true;
					}

					if (attr === attributeKey) {
						return variationValue === match.raw;
					}

					// All other attributes must match the current cart item's attributes.
					return variationValue === currentAttributes[attr];
				});
			});

			if (!target) {
				return { valid: false, maxValue: this.getAutoQuantityMaxValue(ranges) };
			}

			return { valid: true, variationId: target.variation_id };
		}

		// Returns the largest finite upper bound across parsed ranges, or null if open-ended/none.
		getAutoQuantityMaxValue(ranges) {
			if (!ranges || !ranges.length) {
				return null;
			}
			// Open-ended range (e.g. "11+") means there is no real maximum.
			if (ranges.some((r) => r.max === Infinity)) {
				return null;
			}
			return Math.max(...ranges.map((r) => r.max));
		}

		setAutoQuantityRangeWarning($productQuantity, maxValue) {
			const message = maxValue !== null && maxValue !== undefined ? `Max. količina = ${maxValue}` : 'Pogrešna količina';
			const $quantity = $productQuantity.closest('.cart__item-quantity');
			$quantity.attr('data-quantity-range-invalid', 'true');
			this.setCartQuantityMessage(this.getCartQuantityFeedback($quantity).find('.cart__quantity-range-message'), message);
			this.updateCartQuantityAria($quantity);
		}

		clearAutoQuantityRangeWarning($productQuantity) {
			const $quantity = $productQuantity.closest('.cart__item-quantity');
			$quantity.removeAttr('data-quantity-range-invalid');
			this.setCartQuantityMessage(this.getCartQuantityFeedback($quantity).find('.cart__quantity-range-message'), '');
			this.updateCartQuantityAria($quantity);
		}

		reconcileCartVariationMerge($row, data, operation) {
			const $target = this.getCartRoot()
				.find('.cart__item-quantity')
				.filter((index, element) => $(element).attr('data-cart-item-key') === data.cart_item_key)
				.closest('.cart__item')
				.not($row)
				.first();
			if (!$target.length) return;
			const sourceDraft = this.getCartQuantityDraft($row);
			const targetDraft = this.getCartQuantityDraft($target);
			const queuedEdit = this.cartMutationQueue.some((queued) => queued.$row?.is($row) || queued.$row?.is($target));
			if (
				sourceDraft.revision !== operation.revision ||
				targetDraft.quantity !== $target.data('server-quantity') ||
				targetDraft.timer ||
				queuedEdit
			) {
				// Once two rows merge, later edits/removals of either contribution have ambiguous meaning.
				// Preserve their drafts and stop writes until the user reloads the confirmed merged cart.
				this.markCartMutationUncertain('Varijante su spojene u jedan artikl. Osvježite stranicu za nastavak uređivanja košarice.');
				return;
			}
			this.cartQuantityDrafts.delete($target[0]);
			$target.remove();
		}

		// Keep the cart row in sync after a variation switch so further updates/removals target the new item.
		syncCartRowAfterVariationSwitch($cartRow, $input, data) {
			const newVariationId = data.variation_id;
			const newCartItemKey = data.cart_item_key;

			const $inputs = $cartRow.find('.product-quantity__number');
			$inputs.attr('data-variation-id', newVariationId).data('variation-id', newVariationId);

			const $removeButton = $cartRow.find('.js-remove-cart-item');
			$removeButton.attr('data-variation-id', newVariationId).data('variation-id', newVariationId);

			if (newCartItemKey) {
				$inputs.attr('data-cart-item-key', newCartItemKey).data('cart-item-key', newCartItemKey);
				$removeButton.attr('data-cart-item-key', newCartItemKey).data('cart-item-key', newCartItemKey);
				$cartRow.find('.cart__item-quantity').attr('data-cart-item-key', newCartItemKey);
			}

			// Refresh the visible per-unit price for the newly matched variation.
			// The row subtotal/summary are already updated in the success handler; the unit price
			// is the remaining cart item info that changes when switching to a different tier/variation.
			this.updateCartItemUnitPriceAfterVariationSwitch($cartRow, data);

			// Refresh the visible product name + link (text/href/title) for the newly matched variation.
			this.updateCartItemNameAfterVariationSwitch($cartRow, data);
		}

		// Update the visible product name + link (href/title) after an auto-quantity variation switch.
		updateCartItemNameAfterVariationSwitch($cartRow, data) {
			const $nameLink = $cartRow.find('.cart__item-name a').first();
			if (!$nameLink.length) {
				return;
			}

			if (data.item_name && data.item_name !== 'undefined') {
				$nameLink.text(data.item_name).attr('title', data.item_name);
			}

			if (data.permalink) {
				$nameLink.attr('href', data.permalink);
			}
		}

		// Update the cart item's per-unit price using the AJAX response after a variation switch.
		// Price formatting mirrors the single-product variation rendering (de-DE, 2 decimals, &euro;).
		updateCartItemUnitPriceAfterVariationSwitch($cartRow, data) {
			if (data.price === undefined || data.price === null || data.price === '') {
				return;
			}

			const $priceContainer = $cartRow.find('.cart__item-price');
			if (!$priceContainer.length) {
				return;
			}

			const formatted = parseFloat(data.price).toLocaleString('de-DE', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2,
			});
			const priceHtml = formatted + '&nbsp;<span class="woocommerce-Price-currencySymbol">&euro;</span>';

			let $amount = $priceContainer.find('.product__vp-price').first();

			if ($amount.length) {
				$amount.html(priceHtml);
			}
		}

		// Restore the cart UI/controls after aborting or failing a cart update.
		restoreCartUpdateState($cartRow) {
			if ($cartRow && $cartRow.length) {
				$cartRow.removeClass('cart__item--removing');
			}
			this.cart.removeClass('cart--loading');
			this.cartCollaterals.removeClass('cart__collaterals--loading');
		}

		handleUpdateCart($element) {
			const location = $element.data('location');
			const $new_qty = parseFloat($element.data('quantity'));
			const product_id = $element.data('product-id');
			const $input = $element.parent().find('.product-quantity__number:first');

			const data = {
				action: 'w4d_add_to_cart',
				update_cart: location !== 'naruceni-artikli' && location !== 'moji-artikli',
				return_cart_data: false,
				product_id: product_id,
				quantity: $new_qty,
				variation_id: $element.data('variation-id') || 0,
				nonce: w4d_frontend_ajax.nonce,
			};

			$.post({
				url: w4d_frontend_ajax.ajax_url,
				data: data,
				beforeSend: () => {
					this.setButtonLoading($element, true);
				},
				success: (response) => {
					if (response.success) {
						this.handleUpdateCartSuccess(response, $element);
						const toastMsg =
							location === 'naruceni-artikli' || location === 'moji-artikli'
								? 'Artikl je dodan u košaricu.'
								: 'Košarica uspješno ažurirana';
						W4D_Toast.showToast('success', toastMsg);
					} else {
						const cartIcon = $element.parent().find('.product-quantity__cart');
						cartIcon.addClass('product-quantity__cart--error');
						W4D_Toast.showToast('error', response.data?.message || 'Nije moguće spremiti odabranu količinu.');
					}
					const savedQuantity = Number(response.data?.quantity ?? (response.success ? $new_qty : NaN));
					if (location !== 'naruceni-artikli' && location !== 'moji-artikli' && Number.isFinite(savedQuantity)) {
						// Keep a newer draft, but never record a rejected attempt as the saved value.
						if (this.getCartInputQuantity($input) === $new_qty) {
							const display = String(savedQuantity).replace('.', ',');
							$input.val(display).attr('value', savedQuantity).data('starting-value', display);
							$element.attr('data-quantity', savedQuantity).data('quantity', savedQuantity);
							$input.parent().removeClass('product-quantity--changed');
						}
						$input.attr('data-quantity', savedQuantity).data('quantity', savedQuantity).trigger('change');
					}
				},
				complete: () => {
					this.setButtonLoading($element, false);
				},
				error: () => this.handleAddToCartError(),
			});
		}

		handleUpdateCartSuccess(response, input) {
			this.pushCartEvents(response.data);
			const location = input.data('location');
			const totalElement = input.closest('[role="row"], li').find('.product-table__data--item-total, .product-column--price');

			if (location !== 'naruceni-artikli' && location !== 'moji-artikli') {
				totalElement.removeClass('animate-total');
			}

			W4D_FrontendHelper.updateCartIcon(response.data.cart_count);

			const $parent = input.parent();
			$parent.addClass('product-quantity--added-to-cart');
			$parent.find('.product-quantity__cart').removeClass('product-quantity__cart--error');

			if (location !== 'naruceni-artikli' && location !== 'moji-artikli') {
				totalElement.html(response.data.item_total).addClass('animate-total');
				setTimeout(() => totalElement.removeClass('animate-total'), 500);
			}

			setTimeout(() => {
				$parent.removeClass('product-quantity--added-to-cart');
				if (location !== 'naruceni-artikli' && location !== 'moji-artikli') {
					$parent.removeClass('product-quantity--changed');
				}
			}, 2300);
		}

		handleAddToCart(e) {
			e.preventDefault();
			const $button = $(e.currentTarget);
			if ($button.hasClass('loading') || $button.prop('disabled')) return;
			const $qtyInput = $button.parent().find('.product-quantity__number').first();
			const oblpopak = parseFloat($qtyInput.attr('step')) || 1;

			let quantity = 0;

			if ($button.hasClass('single_add_to_cart_button') && $qtyInput) {
				const rawVal = $qtyInput.val() || '0';
				quantity = parseFloat(rawVal.replace(',', '.'));
			} else {
				quantity = parseFloat($button.attr('data-quantity')) || 0;
			}

			if (isNaN(quantity)) {
				quantity = 0;
			}

			if (!(quantity % oblpopak === 0)) {
				quantity = Math.ceil(quantity / oblpopak) * oblpopak;
			}

			if (quantity <= 0) {
				W4D_Toast.showToast('warning', 'Unesite ispravnu količinu.');
				return;
			}

			let productId = $button.data('product-id') || $button.data('product_id');
			let variationId = $button.attr('data-variation-id') || $button.data('variation-id') || 0;

			const $form = $button.closest('form.cart');
			if ($form.length) {
				if (!variationId) {
					variationId = $form.find('[name=variation_id]').val() || 0;
				}
				if (!productId) {
					productId = $form.find('[name=product_id]').val() || $button.val();
				}
			}

			const data = {
				action: 'w4d_add_to_cart',
				product_id: productId,
				quantity: quantity,
				variation_id: variationId,
				nonce: w4d_frontend_ajax.nonce,
			};

			const trackedEvent = this.collectAddToCartEvent($button[0], quantity, parseInt(variationId, 10) || parseInt(productId, 10));
			$.post({
				url: w4d_frontend_ajax.ajax_url,
				data: data,
				beforeSend: () => this.setButtonLoading($button, true),
				success: (response) => {
					if (response.success) this.pushCartEvents(response.data, trackedEvent);
					this.handleAddToCartSuccess(response, $button);
				},
				complete: () => this.setButtonLoading($button, false),
				error: () => this.handleAddToCartError(),
			});
		}

		setupLoadingClickPrevention() {
			$(this.$addToCartButton).on('click', (e) => {
				if ($(e.currentTarget).hasClass('loading')) {
					e.preventDefault();
					e.stopPropagation();
					return false;
				}
			});
		}

		setButtonLoading($button, isLoading) {
			$button.toggleClass('loading', isLoading);
			$button.prop('disabled', isLoading);
			// Mirrored on the card so SCSS can use `.product-card--loading` instead of `:has(.loading)`.
			$button.closest('.product-card').toggleClass('product-card--loading', isLoading);
		}

		handleAddToCartSuccess(response, button) {
			if (response.success) {
				W4D_Toast.showToast('success', 'Artikl je dodan u košaricu.');
				W4D_FrontendHelper.updateCartIcon(response.data.cart_count);

				const productId = button.data('product-id') || button.data('product_id');
				const totalElement = $(`.product-table__row[data-product-id="${productId}"] .product-table__data--item-total`);
				if (totalElement.length) {
					totalElement.html(response.data.item_total);
				}

				if (button.closest('.product-flyout').length) {
					const $flyout = button.closest('.product-flyout');
					const $flyoutQtyInput = $flyout.find('.product-quantity__number').first();
					if ($flyoutQtyInput.length) {
						const addedQty = response.data.added_quantity || 0;
						const $tableRow = $(`.product-table__row[data-product-id="${productId}"]`);
						const $tableQtyInput = $tableRow.find('.product-quantity__number').first();
						if ($tableQtyInput.length) {
							const currentQty = parseFloat($tableQtyInput.val().replace(',', '.')) || 0;
							let newTotalQty = currentQty + addedQty;

							const step = parseFloat($tableQtyInput.attr('step')) || 1;
							if (typeof W4D_ProductQuantityHelper !== 'undefined') {
								const decimalPlaces = W4D_ProductQuantityHelper.getDecimalPlaces(step);
								newTotalQty = W4D_ProductQuantityHelper.roundToDecimalPlaces(newTotalQty, decimalPlaces);
							}

							const displayValue = String(newTotalQty).replace('.', ',');
							$tableQtyInput.val(displayValue);
							$tableQtyInput.attr('data-quantity', newTotalQty);
							$tableQtyInput.data('quantity', newTotalQty);
							$tableQtyInput.trigger('change');

							$tableRow.find('.product-quantity').addClass('product-quantity--added-to-cart');
							setTimeout(() => {
								$tableRow.find('.product-quantity').removeClass('product-quantity--added-to-cart');
							}, 2300);
						}
					}
				}
			} else {
				W4D_Toast.showToast('error', 'Greška: ' + response.data.message);
				console.error(response.data.message);
			}
		}

		handleAddToCartError() {
			W4D_Toast.showToast('error', 'Došlo je do greške prilikom dodavanja artikla u košaricu.');
		}

		// >----------------------------------------- VARIABLE PRODUCT METHODS -----------------------------------------<

		handleVariationChange(e = null) {
			let $container;

			if (e && e.currentTarget) {
				$container = $(e.currentTarget).closest('.variations_container');
			} else {
				$container = $('.variations_container').first();
			}

			this.setupLoadingClickPrevention();

			const selectedAttributes = this.getSelectedAttributes($container);
			const selectedFromRadios = this.getSelectedAttributesFromRadios($container);
			const selectedCombined = { ...selectedAttributes, ...selectedFromRadios };

			this.updateAllVariationOptions(selectedCombined, $container);

			const matchingVariation = this.findMatchingVariation(selectedCombined, $container);
			if (matchingVariation) {
				this.updateVariationData(matchingVariation);
			} else {
				this.resetVariationData();
			}
		}

		// Called when a Color radio changes
		handleAdvancedVariationChange(e) {
			const $container = $(e.currentTarget).closest('.variations_container');

			// 1) Radios (Color)
			const selectedFromRadios = this.getSelectedAttributesFromRadios($container);

			// 2) Selects (Number, Type)
			const selectedFromSelects = this.getSelectedAttributes($container);

			// 3) Combine them
			const selectedCombined = { ...selectedFromSelects, ...selectedFromRadios };

			// 4) Update ALL options based on combined selection
			this.updateAllVariationOptions(selectedCombined, $container);

			// 6) Try to find a full match; it will only match when all attributes are selected
			const matchingVariation = this.findMatchingVariation(selectedCombined, $container);
			if (matchingVariation) {
				this.updateVariationData(matchingVariation);
			} else {
				this.resetVariationData();
			}
		}

		updateAllVariationOptions(selectedCombined, $container) {
			// Update select dropdowns
			this.updateSelectOptionsBasedOnCombined(selectedCombined, $container);

			// Update radio buttons
			this.updateRadioOptionsBasedOnCombined(selectedCombined, $container);
		}

		handleAdvancedAttributeNameChange(attrName, value, $container) {
			if (this.isClearing) {
				return;
			}

			// Ensure we have a store for original label texts
			if (!this._originalLabelText) {
				this._originalLabelText = {};
			}

			// 1) Strip the "attribute_" prefix and handle item suffix
			const attrNamePretty = String(attrName)
				.replace(/^attribute_/, '')
				.replace(/_item_\d+$/, '');

			// 2) Find the corresponding label by its "for" attribute
			// Your markup uses: <label for="...">...</label>
			const $label = $container.find(`.variations label[for="${attrNamePretty}"]`).first();
			if (!$label.length) {
				return;
			}

			const original = $label.attr('data-original-text') || '';

			if (value && value.length) {
				// Get the template and clone its content
				const template = document.getElementById('icon-x');
				const iconClone = template.content.cloneNode(true);

				// Create the remove button element
				const $button = $('<button class="variations__remove"></button>');
				$button.append(iconClone);

				// Build the label HTML and append the button
				$label.html(`${original}<span>: </span>` + `<span class="fw-400 leading-none">${value}</span>`);
				$label.append($button);
			} else {
				$label.html(original);
			}
		}

		updateSelectOptionsBasedOnCombined(selectedCombined, $container) {
			const $selects = $container.find('.variations select');

			$selects.each((_, select) => {
				const $select = $(select);
				const attributeName = $select.data('attribute_name');

				// Build a selection WITHOUT this specific select's attribute
				// to see what values are possible for THIS select
				const baseSelected = { ...selectedCombined };
				delete baseSelected[attributeName];

				const possibleValues = this.getPossibleValuesForAttribute(attributeName, baseSelected, $container);

				// Enable/disable options
				$select.find('option').each(function () {
					const $opt = $(this);
					const optionValue = $opt.attr('value');

					if (optionValue === '') {
						$opt.prop('disabled', false);
						return;
					}

					const allowed = possibleValues.has(optionValue);
					$opt.prop('disabled', !allowed);
				});

				// If current value is no longer valid, clear it
				const currentValue = $select.val();
				if (currentValue && currentValue !== '' && !possibleValues.has(currentValue)) {
					$select.val('');
				}
			});
		}

		updateRadioOptionsBasedOnCombined(selectedCombined, $container) {
			// Collect all radio group names
			const groupNames = new Set();
			$container.find('.variations__input[type="radio"]').each(function () {
				let name = $(this).attr('name');
				const cleanName = name.replace(/_item_\d+$/, '');
				if (cleanName) {
					groupNames.add(cleanName);
				}
			});

			groupNames.forEach((attributeName) => {
				const $radios = $container.find('.variations__input[type=radio]').filter(function () {
					const radioName = $(this).attr('name');
					const cleanName = radioName.replace(/_item_\d+$/, '');
					return cleanName === attributeName;
				});

				// Build a selection that EXCLUDES this radio group's attribute
				const baseSelected = { ...selectedCombined };
				delete baseSelected[attributeName];

				// If there are NO other selections, all radios in this group should be enabled
				const hasOtherSelections = Object.keys(baseSelected).length > 0;

				if (!hasOtherSelections) {
					$radios.each(function () {
						const $radio = $(this);
						$radio.prop('disabled', false);
						$radio.next('.variations__label').removeClass('is-disabled');
					});
				} else {
					// Get possible values for this radio group given other selections
					const possibleValues = this.getPossibleValuesForAttribute(attributeName, baseSelected, $container);

					$radios.each(function () {
						const $radio = $(this);
						const val = $radio.val();
						const isAllowed = val && possibleValues.has(val);

						$radio.prop('disabled', !isAllowed);
						$radio.next('.variations__label').toggleClass('is-disabled', !isAllowed);

						// If this radio is currently checked but is no longer allowed, uncheck it
						if (!isAllowed && $radio.is(':checked')) {
							$radio.prop('checked', false);
						}
					});
				}

				// Update the main label for this attribute group
				const $checkedRadio = $radios.filter(':checked');
				if ($checkedRadio.length) {
					const $label = $checkedRadio.next('.variations__label');
					const labelText = ($label.attr('title') || '').trim();
					this.handleAdvancedAttributeNameChange(attributeName, labelText, $container);
				} else {
					this.handleAdvancedAttributeNameChange(attributeName, '', $container);
				}
			});
		}

		// Build selection from radios (Color)
		getSelectedAttributesFromRadios($container) {
			const attributes = {};
			$container.find('.variations__input[type="radio"]:checked').each(function () {
				const $radio = $(this);
				let attrName = $radio.attr('name');
				const value = $radio.val();
				attrName = attrName.replace(/_item_\d+$/, '');

				if (attrName && value) {
					attributes[attrName] = value;
				}
			});
			return attributes;
		}

		// Build selection from selects (Number, Type)
		getSelectedAttributes($container) {
			const attributes = {};
			const $selects = $container.find('.variations select');

			$selects.each(function () {
				const attributeName = $(this).data('attribute_name');
				const attributeValue = $(this).val();
				if (attributeValue && attributeValue.length > 0) {
					attributes[attributeName] = attributeValue;
				}
			});
			return attributes;
		}

		// Return the first variation that exactly matches all selected attributes
		findMatchingVariation(attributes, $container) {
			const productVariations = $container.data('product_variations') || [];
			return productVariations.find((variation) =>
				Object.entries(variation.attributes).every(([attr_name, attr_value]) => attributes[attr_name] === attr_value)
			);
		}

		// Return all variations compatible with the current (possibly partial) selection
		findMatchingVariations(selectedAttributes, $container) {
			const productVariations = $container.data('product_variations') || [];
			return productVariations.filter((variation) => {
				for (const attr in selectedAttributes) {
					if (selectedAttributes[attr] && selectedAttributes[attr] !== variation.attributes[attr]) {
						return false;
					}
				}
				return true;
			});
		}

		// For a target attribute, return the set of values still possible given current (partial) selection
		getPossibleValuesForAttribute(attributeName, selectedAttributes, $container) {
			const matchedVariations = this.findMatchingVariations(selectedAttributes, $container);
			const possibleValues = new Set();
			matchedVariations.forEach((variation) => {
				if (variation.attributes[attributeName]) {
					possibleValues.add(variation.attributes[attributeName]);
				}
			});
			return possibleValues;
		}

		updateVariationData(variation) {
			const oldVariationId = this.currentVariationId;
			if (oldVariationId === variation.variation_id) {
				return;
			}

			this.currentVariationId = variation.variation_id;
			const wasShowingOriginal = this.isShowingOriginal;
			this.isShowingOriginal = false;

			// Track matching state on the sidebar/flyout container for external reference and CSS
			this.$sidebarInfo.attr('data-is-matching', 'true');
			$('.product-sidebar-wrapper').attr('data-is-matching', 'true');

			$(this.$addToCartButton)
				.prop('disabled', false)
				.attr('data-variation-id', variation.variation_id)
				.data('variation-id', variation.variation_id);

			const $form = $(this.$addToCartButton).closest('form.cart');
			if ($form.length) {
				$form.find('[name=variation_id]').val(variation.variation_id);
				$form.trigger('found_variation', [variation]);
			}

			const $inquiryBtn = $(this.$sendInquiryContainer).find('.w4d-send-inquiry');
			if ($inquiryBtn.length) {
				const baseHref = $inquiryBtn.attr('data-base-href') || $inquiryBtn.attr('href').split('?')[0];
				if (!$inquiryBtn.attr('data-base-href')) {
					$inquiryBtn.attr('data-base-href', baseHref);
				}
				$inquiryBtn.attr('href', baseHref + '?id=' + variation.variation_id);
			}

			$('.product-sidebar__info').find('[data-js-product-ident]').text(variation.ident);
			this.updateStockStatus(variation);
			this.updateDescription(variation);
			this.updatePrice(variation, wasShowingOriginal);
			this.updateImage(variation);
			this.updateAttributes(variation);
			this.updateMetaData(variation);
			this.updateDocs(variation);
			this.updateProizvodjac(variation);
			this.updateRelatedProducts(variation);

			if (this.isProductTemplatePage) {
				const queryString = new URLSearchParams(variation.attributes).toString();
				const newUrl = window.location.pathname + '?' + queryString;
				history.replaceState(null, '', newUrl);

				let $povezani_var_artikli_anchor_list = $('.povezani-var-artikli__list>a');
				if ($povezani_var_artikli_anchor_list.length) {
					$povezani_var_artikli_anchor_list.each(function () {
						let href = $(this).attr('href');
						if (href) {
							try {
								let url = new URL(href, window.location.href);
								let newParams = new URLSearchParams(queryString);
								for (let [key, value] of newParams.entries()) {
									url.searchParams.set(key, value);
								}
								$(this).attr('href', url.toString());
							} catch (e) {
								console.error('Error updating URL parameters', e);
							}
						}
					});
				}
			}
		}

		resetVariationData() {
			const isMatching = this.$sidebarInfo.attr('data-is-matching') === 'true';
			const $variationQuantity = $(this.variationQuantity);
			const $container = $('.variations_container').first();
			const isAutoQtyEnabled = $container.data('js-auto-quantity-variation-selection') === 1;

			// Function to handle removing quantity elements with a smooth collapse animation
			const removeQuantityWithAnimation = ($container) => {
				if (isAutoQtyEnabled) {
					return;
				}
				const $inner = $container.find('.woocommerce-variation-quantity__inner');
				if ($inner.length > 0) {
					$inner.addClass('woocommerce-variation-quantity__inner--closing');
					const node = $inner[0];
					let transitionHandled = false;

					const handleTransitionEnd = (e) => {
						if (transitionHandled) return;

						// Only remove if it was the height/opacity transition that ended
						if (e.propertyName === 'grid-template-rows' || e.propertyName === 'opacity') {
							transitionHandled = true;
							$container.empty();
							node.removeEventListener('transitionend', handleTransitionEnd);
						}
					};

					node.addEventListener('transitionend', handleTransitionEnd);

					// Fallback cleanup if transitionend doesn't fire
					setTimeout(() => {
						if (!transitionHandled && $container.contents().length) {
							$container.empty();
							node.removeEventListener('transitionend', handleTransitionEnd);
						}
					}, 600);
				} else {
					$container.empty();
				}
			};

			// Function to handle removing availability elements with a smooth collapse animation
			const removeAvailabilityWithAnimation = ($sidebar) => {
				const $availability = $sidebar.find('.product-availability:not([popover])');
				const $toggle = $sidebar.find('.product-availability-toggle');

				if ($availability.length > 0) {
					$availability.addClass('product-availability--closing');

					const availabilityNode = $availability[0];
					let transitionHandled = false;

					const handleTransitionEnd = (e) => {
						if (transitionHandled) return;

						// Only remove if it was the height/opacity transition that ended
						if (e.propertyName === 'grid-template-rows' || e.propertyName === 'opacity') {
							transitionHandled = true;
							$availability.remove();
							$toggle.remove();
							availabilityNode.removeEventListener('transitionend', handleTransitionEnd);
						}
					};

					availabilityNode.addEventListener('transitionend', handleTransitionEnd);

					// Fallback cleanup if transitionend doesn't fire
					setTimeout(() => {
						if (!transitionHandled && $availability.parent().length) {
							$availability.remove();
							$toggle.remove();
							availabilityNode.removeEventListener('transitionend', handleTransitionEnd);
						}
					}, 600);
				} else {
					$sidebar.find('.product-availability, .product-availability-toggle').remove();
				}
			};

			if (isMatching) {
				removeAvailabilityWithAnimation(this.$sidebarInfo);
				removeQuantityWithAnimation($variationQuantity);
			} else {
				// If we're already in non-matching state, just ensure they are gone
				if (!isAutoQtyEnabled) {
					this.$sidebarInfo.find('.product-availability, .product-availability-toggle').remove();
					$variationQuantity.empty();
				}
			}

			// Clear matching state on the sidebar/flyout and wrapper
			this.$sidebarInfo.removeAttr('data-is-matching');
			$('.product-sidebar-wrapper').removeAttr('data-is-matching');

			if (!isMatching && this.isShowingOriginal) {
				// If we are already showing the original state and we weren't in a matching state,
				// don't trigger the animation or restoration again.
				return;
			}

			this.currentVariationId = null;
			this.isShowingOriginal = true;

			if (this.isProductTemplatePage) {
				history.replaceState(null, '', window.location.pathname);
				let $povezani_var_artikli_anchor_list = $('.povezani-var-artikli__list>a');
				if ($povezani_var_artikli_anchor_list.length) {
					$povezani_var_artikli_anchor_list.each(function () {
						let href = $(this).attr('href');
						if (href) {
							try {
								let url = new URL(href, window.location.href);
								url.search = ''; // Clears all query parameters
								$(this).attr('href', url.toString());
							} catch (e) {
								console.error('Error updating URL parameters', e);
							}
						}
					});
				}
			}

			// Ident and other small fields don't have height animations, we can always reset them.
			$('.product-sidebar__info').find('[data-js-product-ident]').text('-');
			$(this.variationPrice).empty();

			$(this.priceWrapper).each(function () {
				const $wrapper = $(this);
				const originalHtml = $wrapper.attr('data-original-html');
				if (!originalHtml) return;

				// We are coming from a Match state because isMatching was true,
				// or we are just ensuring consistency.
				// We restore originalHtml here to trigger the collapse animation.
				$wrapper.html(originalHtml);
			});

			if ($('.variations_container').length) {
				$(this.$addToCartButton).prop('disabled', true).removeData('variation-id').attr('aria-hidden', false);
				const $form = $(this.$addToCartButton).closest('form.cart');
				if ($form.length) {
					$form.find('[name=variation_id]').val('0');
				}
			}
			$(this.$sendInquiryContainer).attr('aria-hidden', true);

			const $variationsContainer = $(this.$addToCartButton).closest('.variations_container');
			if ($variationsContainer.length) {
				$variationsContainer.find(this.availabilityBtn).addClass('hidden');
			} else {
				$(this.availabilityBtn).addClass('hidden');
			}

			$('[data-attr-value]').each(function () {
				const value = $(this).attr('data-attr-value');
				$(this).html(value);
			});
			this.resetStockStatus();
			$('[data-document-id]').attr('aria-hidden', true);

			const hasDocs = $('[data-document-id]').filter((i, el) => $(el).attr('aria-hidden') !== 'true').length > 0;
			const hasParentDocElements = $('[data-parent-doc]').length > 0;
			$('[data-document-id]')
				.closest('#summary-documents')
				.attr('aria-hidden', !hasDocs && !hasParentDocElements);

			const $hasDescription = this.$summaryDescription.attr('data-attr-value')?.trim().length > 0;
			$('#summary-description').attr('aria-hidden', !$hasDescription);

			const $hasProizvodjac = this.$summaryProizvodjac.attr('data-attr-value')?.trim().length > 0;
			$('#summary-proizvodjac').attr('aria-hidden', !$hasProizvodjac);
		}

		getStockStatusElements() {
			return $('.product-sidebar__info .availability[data-default-stock-status]');
		}

		getStockStatusLabel(status) {
			const labels = window.w4d_frontend_ajax?.stock_status_labels || {};

			return labels[status] || labels.instock || '';
		}

		setStockStatus($elements, status) {
			const allowedStatuses = ['instock', 'outofstock', 'onbackorder'];
			const normalizedStatus = allowedStatuses.includes(status) ? status : 'instock';
			const text = this.getStockStatusLabel(normalizedStatus);
			const modifierClasses = allowedStatuses.map((item) => `availability--${item}`);

			$elements.each((index, element) => {
				const $element = $(element);
				const $text = $element.find('span').first();

				$element.removeClass(modifierClasses.join(' ')).addClass(`availability--${normalizedStatus}`);

				if ($text.length) {
					$text.text(text);
					return;
				}

				$element.attr('aria-label', text).attr('data-tippy-content', text);

				if (element._tippy) {
					element._tippy.setContent(text);
				}
			});
		}

		updateStockStatus(variation) {
			const $elements = this.getStockStatusElements();
			const stockStatus = this.getVariationStockStatus(variation);

			this.setStockStatus($elements, stockStatus);
		}

		getVariationStockStatus(variation) {
			const allowedStatuses = ['instock', 'outofstock', 'onbackorder'];

			if (allowedStatuses.includes(variation?.stock_status)) {
				return variation.stock_status;
			}

			if (variation?.is_on_backorder) {
				return 'onbackorder';
			}

			if (variation?.is_in_stock === false) {
				return 'outofstock';
			}

			return 'instock';
		}

		resetStockStatus() {
			this.getStockStatusElements().each((index, element) => {
				const $element = $(element);

				this.setStockStatus($element, $element.data('default-stock-status'));
			});
		}

		updateDescription(variation) {
			// Target the div inside the summary description container
			const $targetDiv = this.$summaryDescription;

			if (variation.variation_description?.trim()) {
				// Empty the inner div and append the new description
				$targetDiv.empty().append(variation.variation_description);
				$('#summary-description').attr('aria-hidden', false);
			} else if (this.$summaryDescription.attr('data-attr-value')?.trim().length > 0) {
				// Fallback to data attribute value if variation description is missing
				$targetDiv.html(this.$summaryDescription.attr('data-attr-value'));
				$('#summary-description').attr('aria-hidden', false);
			} else {
				// Hide parent if no description is available
				$('#summary-description').attr('aria-hidden', true);
			}
		}

		updateProizvodjac(variation) {
			const $targetDiv = this.$summaryProizvodjac;

			if (variation.proizvodjac_html?.trim()) {
				$targetDiv.empty().append(variation.proizvodjac_html);
				$('#summary-proizvodjac').attr('aria-hidden', false);
			} else if (this.$summaryProizvodjac.attr('data-attr-value')?.trim().length > 0) {
				$targetDiv.html(this.$summaryProizvodjac.attr('data-attr-value'));
				$('#summary-proizvodjac').attr('aria-hidden', false);
			} else {
				$('#summary-proizvodjac').attr('aria-hidden', true);
			}
		}

		updatePrice(variation, wasShowingOriginal = false) {
			let $variationPrice = $(this.variationPrice);
			let $priceWrapper = $(this.priceWrapper);
			let $variationQuantity = $(this.variationQuantity);

			const $vContainer = $('.variations_container').first();
			const isAutoQtyEnabled = $vContainer.data('js-auto-quantity-variation-selection') === 1;

			$variationPrice.empty();

			const isPriceWrapper = !!$priceWrapper.length;
			let $targetPrice;
			let $targetQuantity;

			if (isPriceWrapper) {
				// Determine if we should animate height.
				// We animate height only when coming from original state.
				const innerClass = wasShowingOriginal ? 'price-wrapper__inner' : 'price-wrapper__inner price-wrapper__inner--no-height';
				$priceWrapper.empty();
				$targetPrice = $(`<div class="${innerClass}"></div>`).appendTo($priceWrapper);
			} else {
				$targetPrice = $variationPrice;
			}

			if ($variationQuantity.length) {
				const innerClass = wasShowingOriginal
					? 'woocommerce-variation-quantity__inner'
					: 'woocommerce-variation-quantity__inner woocommerce-variation-quantity__inner--no-height';
				const $existingInner = $variationQuantity.find('.woocommerce-variation-quantity__inner');

				if (isAutoQtyEnabled && $existingInner.length > 0) {
					$targetQuantity = $existingInner;
				} else {
					$variationQuantity.empty();
					$targetQuantity = $(`<div class="${innerClass}"></div>`).appendTo($variationQuantity);
				}
			} else {
				$targetQuantity = $targetPrice;
			}

			if (this.availabilityLocationsTemplate) {
				const $existingAvailability = this.$sidebarInfo.find('.product-availability:not([popover])');
				const wasShowingAvailability = $existingAvailability.length > 0;

				this.$sidebarInfo.find('.product-availability, .product-availability-toggle').remove();

				if (!this.$samoPregled_showPrice) {
					const $stanja = JSON.parse(variation.stanje_skl || '[]');
					if (Array.isArray($stanja) && $stanja.length > 0) {
						const templateContent = this.availabilityLocationsTemplate.content.cloneNode(true);
						const $availabilityContainer = $(templateContent).find('.product-availability');
						const $list = $(templateContent).find('.product-availability__list');

						// We use no-height if we were already showing availability (match-to-match switch)
						if (wasShowingAvailability) {
							$availabilityContainer.addClass('product-availability--no-height');
						}

						$stanja.forEach((stanje) => {
							const raspolozivoFormatted = new Intl.NumberFormat('en-US').format(stanje.raspolozivo);
							const raspolozivoText = stanje.raspolozivo > 0 ? ` (${raspolozivoFormatted})` : '';
							const stockClass = stanje.raspolozivo > 0 ? 'availability' : 'availability availability--onbackorder';

							$list.append(`<li><div class="${stockClass}">${stanje.naziv}${raspolozivoText}</div></li>`);
						});

						this.$sidebarInfo.append(templateContent);
					}
				}
			}

			if (variation.hide_price) {
				$(this.$sendInquiryContainer).attr('aria-hidden', false);
				$(this.$addToCartButton).attr('aria-hidden', true);

				const $variationsContainer = $(this.$addToCartButton).closest('.variations_container');
				if ($variationsContainer.length) {
					$variationsContainer.find(this.availabilityBtn).addClass('hidden');
				} else {
					$(this.availabilityBtn).addClass('hidden');
				}

				$targetPrice.append(
					'<div class="variation__price">' + '<div class="variation__price-regular">CIJENA NA UPIT</div>' + '</div>'
				);

				let $form = $('#w4d-fb-contact-default');
				let $identInput = $form.find('input#Ident');
				$identInput.val($identInput.attr('data-ident-label') + ': ' + variation.ident);
				$form.find('input#Artikl').val(variation.name);

				return;
			}

			const regularPrice = parseFloat(variation.display_regular_price);
			const regularPriceText = regularPrice.toLocaleString('de-DE', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2,
			});
			const salePrice = parseFloat(variation.display_price);
			const salePriceText = salePrice.toLocaleString('de-DE', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2,
			});

			const hasValidSale =
				variation.display_regular_price && variation.display_price && variation.display_regular_price > variation.display_price;
			const display_jm1_variable = $variationPrice.closest('.single_variation_wrap').hasClass('display_jm1');

			if (hasValidSale) {
				const lowestPrice =
					variation.lowest_price_30_days && parseFloat(variation.lowest_price_30_days) > 0
						? parseFloat(variation.lowest_price_30_days)
						: regularPrice;

				const discountPercentage = variation.discount_percentage ?? Math.round(((lowestPrice - salePrice) / lowestPrice) * 100);

				let level = 'medium';
				if (discountPercentage > 49) level = 'high';
				else if (discountPercentage >= 0 && discountPercentage < 25) level = 'low';

				const discountClass = `variation__price-sale discount--${level}`;

				let discountAttr = '';
				if (discountPercentage > 0) {
					discountAttr = ' data-discount="-' + discountPercentage + '%"';
				} else if (discountPercentage < 0) {
					discountAttr = ' data-discount="AKCIJA"';
				}

				$targetPrice.append(
					'<div class="variation__price">' +
						'<div class="' +
						discountClass +
						'"' +
						discountAttr +
						'>' +
						salePriceText +
						' <span class="woocommerce-Price-currencySymbol">&euro;</span>' +
						(display_jm1_variable ? '<span class="product_jm1_display"> /' + variation.pakovanje + '</span>' : '') +
						'</div>' +
						'<div class="variation__price-regular variation__price-regular--crossed">' +
						regularPriceText +
						' <span class="woocommerce-Price-currencySymbol">&euro;</span>' +
						'</div>' +
						'</div>'
				);

				// Consumer information only; the plugin hides it from VAT-exempt (B2B) customers.
				if (!variation.hide_lowest_price_30_days) {
					const lowestPriceText = lowestPrice.toLocaleString('de-DE', {
						minimumFractionDigits: 2,
						maximumFractionDigits: 2,
					});
					$targetPrice.append(
						`<small class="price__lowest">Najniža cijena u 30 dana: ${lowestPriceText}&nbsp;<span class="woocommerce-Price-currencySymbol">&euro;</span></small>`
					);
				}
			} else {
				$targetPrice.append(
					'<div class="variation__price">' +
						'<div class="variation__price-regular">' +
						regularPriceText +
						'&nbsp;<span class="woocommerce-Price-currencySymbol">&euro;</span>' +
						(display_jm1_variable ? '<span class="product_jm1_display"> /' + variation.pakovanje + '</span>' : '') +
						'</div>' +
						'</div>'
				);
			}

			if (variation.sidrena_cijena && parseFloat(variation.sidrena_cijena) > 0 && variation.sidrena_cijena_datum) {
				const sidrenaCijenaNum = parseFloat(variation.sidrena_cijena);
				const sidrenaCijenaText = sidrenaCijenaNum.toLocaleString('hr-HR', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				});
				const dateParts = variation.sidrena_cijena_datum.split('-');
				const formattedDate =
					dateParts.length === 3 ? `${dateParts[2]}.${dateParts[1]}.${dateParts[0]}` : variation.sidrena_cijena_datum;

				$targetPrice.append(
					`<small class="price__anchor">Cijena na dan ${formattedDate}: <data value="${variation.sidrena_cijena}" class="price__anchor__value">${sidrenaCijenaText}&nbsp;<span class="woocommerce-Price-currencySymbol">&euro;</span></data></small>`
				);
			}

			if (variation.stock_status === 'outofstock') {
				$(this.$sendInquiryContainer).attr('aria-hidden', false);

				const $variationsContainer = $(this.$addToCartButton).closest('.variations_container');
				if ($variationsContainer.length) {
					$variationsContainer.find(this.availabilityBtn).removeClass('hidden').attr('data-variation-id', variation.variation_id);
				} else {
					$(this.availabilityBtn).removeClass('hidden').attr('data-variation-id', variation.variation_id);
				}

				$(this.$addToCartButton).attr('aria-hidden', true);

				let $form = $('#w4d-fb-contact-default');
				let $identInput = $form.find('input#Ident');
				$identInput.val($identInput.attr('data-ident-label') + ': ' + variation.ident);
				$form.find('input#Artikl').val(variation.name);
				return;
			}

			$(this.$sendInquiryContainer).attr('aria-hidden', true);

			const $variationsContainer = $(this.$addToCartButton).closest('.variations_container');
			if ($variationsContainer.length) {
				$variationsContainer.find(this.availabilityBtn).addClass('hidden');
			} else {
				$(this.availabilityBtn).addClass('hidden');
			}

			$(this.$addToCartButton).attr('aria-hidden', false);

			const variationId = variation.variation_id;
			const oblpopak = variation.oblpopak;
			const pakovanje = variation.pakovanje;
			const faktoroblika = parseFloat(variation.faktoroblika);
			const oblik = variation.oblik;

			if (faktoroblika != 1) {
				const oblikPrice = (salePrice / faktoroblika).toLocaleString('de-DE', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				});
				$targetPrice.append(
					'<small class="price__secondary">' +
						oblik +
						' = ' +
						oblikPrice +
						'<span class="woocommerce-Price-currencySymbol">&euro;</span>' +
						'</small>'
				);
			}

			let decimalPlaces = W4D_ProductQuantityHelper.getDecimalPlaces(oblpopak);
			let value = W4D_ProductQuantityHelper.roundToDecimalPlaces(oblpopak, decimalPlaces);
			let displayValue = value.toString().replace('.', ',');

			let decimalPlaces2 = W4D_ProductQuantityHelper.getDecimalPlaces(faktoroblika);
			let value2 = W4D_ProductQuantityHelper.roundToDecimalPlaces(oblpopak * faktoroblika, decimalPlaces2);
			let displayValue2 = value2.toString().replace('.', ',');

			if (this.$samoPregled_showPrice) return;

			if (isAutoQtyEnabled && $targetQuantity.find('.product-quantity__number').length > 0) {
				// Update variation ID on dual wrapper if it exists
				$targetQuantity.find('.product-quantity__dual').attr('data-variation-id', variationId).data('variation-id', variationId);
				return;
			}

			if (faktoroblika == 1) {
				const $template = $('#product-quantity').prop('content');
				const $container = $($template).find('.product-quantity').clone();
				const $input = $container.find('input');
				const $unit = $container.find('.product-quantity__unit');
				const $cart = $container.find('.product-quantity__cart');

				$container.attr('data-step', oblpopak);
				$input
					.val(displayValue)
					.attr({
						value: displayValue,
						step: oblpopak,
						'data-quantity': oblpopak,
						'data-faktor': faktoroblika,
					})
					.addClass('js-jm2');
				$unit.text(oblik);
				$cart.remove(); // Remove cart icon for variation

				$targetQuantity.append($container);
			} else {
				const $dualWrapper = $('<div class="product-quantity__dual" data-variation-id="' + variationId + '"></div>');

				// First quantity input (jm1 - pakovanje)
				const $template1 = $('#product-quantity').prop('content');
				const $quantity1 = $($template1).find('.product-quantity').clone();
				const $input1 = $quantity1.find('input');
				const $unit1 = $quantity1.find('.product-quantity__unit');
				const $cart1 = $quantity1.find('.product-quantity__cart');

				$quantity1.attr('data-step', oblpopak);
				$input1
					.val(displayValue)
					.attr({
						value: displayValue,
						min: oblpopak,
						step: oblpopak,
						'data-quantity': oblpopak,
						'data-faktor': faktoroblika,
					})
					.addClass('js-jm1');
				$unit1.text(pakovanje);
				$cart1.remove();

				// Second quantity input (jm2 - oblik)
				const $template2 = $('#product-quantity').prop('content');
				const $quantity2 = $($template2).find('.product-quantity').clone();
				const $input2 = $quantity2.find('input');
				const $unit2 = $quantity2.find('.product-quantity__unit');
				const $cart2 = $quantity2.find('.product-quantity__cart');

				$quantity2.attr('data-step', '1').addClass('product-quantity__jm2');
				$input2
					.val(displayValue2)
					.attr({
						value: displayValue2,
						min: value2,
						step: value2,
						'data-quantity': value2,
						'data-faktor': faktoroblika,
					})
					.addClass('js-jm2');
				$unit2.text(oblik);
				$cart2.remove();

				// Assemble dual quantity
				$dualWrapper.append($quantity1);
				$dualWrapper.append('<span class="text-bold">=</span>');
				$dualWrapper.append($quantity2);

				$targetQuantity.append($dualWrapper);
			}
		}

		updateImage(variation) {
			if (!variation?.image_id || variation.image_id <= 0) return;

			const $mainGalleryLinks = $('.js-product-gallery > a');

			const tryActivateThumbnail = (retries = 2) => {
				let $thumb = $(`.product-gallery__thumbnail[data-id="${variation.image_id}"]`);
				const $thumbContainer = $('.product-gallery__thumbnails');

				if ($thumb.length) {
					$('.product-gallery__thumbnail').removeClass('active').attr('aria-selected', 'false');
					$thumb.addClass('active').attr('aria-selected', 'true');

					if ($thumbContainer.length) {
						const scrollTop = $thumbContainer.scrollTop();
						const targetTop = $thumb.position().top + scrollTop - 40;
						$thumbContainer.animate({ scrollTop: targetTop }, 300);
					}
				} else if (retries > 0) {
					setTimeout(() => tryActivateThumbnail(retries - 1), 100);
				} else {
					$thumb = $(`.product-gallery__thumbnail[data-id="0"]`);

					$('.product-gallery__thumbnail').removeClass('active').attr('aria-selected', 'false');
					$thumb.addClass('active').attr('aria-selected', 'true');

					if ($thumbContainer.length) {
						const scrollTop = $thumbContainer.scrollTop();
						const targetTop = $thumb.position().top + scrollTop - 40;
						$thumbContainer.animate({ scrollTop: targetTop }, 300);
					}
				}
			};

			tryActivateThumbnail();

			const targetSrc = variation.image?.src?.split('?')[0] ?? '';
			let matchedIndex = -1;

			// By attachment ID (data-image-id), else by the original's URL in <img src>.
			$mainGalleryLinks.each(function (index) {
				const $img = $(this).find('img');
				const imgSrc = $img.attr('src')?.split('?')[0];
				if (parseInt($img.attr('data-image-id'), 10) === parseInt(variation.image_id, 10) || imgSrc === targetSrc) {
					matchedIndex = index;
					return false;
				}
			});

			if (matchedIndex !== -1) {
				$mainGalleryLinks.removeClass('active').attr('aria-current', 'false');
				$mainGalleryLinks.eq(matchedIndex).addClass('active').attr('aria-current', 'true');

				const newMainSrc = $mainGalleryLinks.eq(matchedIndex).find('img').attr('src');
				$('.product-gallery__main img').attr('src', newMainSrc);
			}
		}

		updateAttributes(variation) {
			Object.entries(variation.attributes).forEach(([attr_name, attr_value]) => {
				const $term = $(`.def-list__term[data-attribute="${attr_name}"]`);
				const optionSlugs = $term.attr('data-slugs');

				if (optionSlugs) {
					const options = JSON.parse(optionSlugs);
					if (options[attr_value]) {
						let name = options[attr_value].name ?? 'N/A';
						let link = options[attr_value]?.link;
						if (link) {
							let anchorElement = '<a href="' + link + '" class="link">' + name + '</a>';
							$term.next('.def-list__definition').html(anchorElement);
						} else {
							$term.next('.def-list__definition').text(name);
						}
					}
				}
			});

			if (variation.additional_attributes) {
				Object.entries(variation.additional_attributes).forEach(([attr_name, attr_value]) => {
					const $term = $(`.def-list__term[data-attribute="${attr_name}"]`);
					const optionSlugs = $term.attr('data-slugs');

					if (optionSlugs) {
						const options = JSON.parse(optionSlugs);
						if (options[attr_value]) {
							let name = options[attr_value].name ?? 'N/A';
							let link = options[attr_value]?.link;
							if (link) {
								let anchorElement = '<a href="' + link + '" class="link">' + name + '</a>';
								$term.next('.def-list__definition').html(anchorElement);
							} else {
								$term.next('.def-list__definition').text(name);
							}
						}
					}
				});
			}
		}

		updateMetaData(variation) {
			const $weightAttr = $('.tezina-value');
			if ($weightAttr && $weightAttr != undefined && $weightAttr.length > 0) {
				if (variation.weight_html && variation.weight_html !== 'N/A') {
					$weightAttr.html(variation.weight_html);
				} else {
					const allWeights = $weightAttr.attr('data-attr-value');
					$weightAttr.html(allWeights || '');
				}
			}

			const $dimensionsAttr = $('.dimenzije-value');

			if ($dimensionsAttr && $dimensionsAttr != undefined && $dimensionsAttr.length > 0) {
				if (variation.dimensions_html && variation.dimensions_html !== 'N/A') {
					$dimensionsAttr.html(variation.dimensions_html);
				} else {
					const allDimensions = $dimensionsAttr.attr('data-attr-value');
					$dimensionsAttr.html(allDimensions || '');
				}
			}

			const $barkodAttr = $('.barkod-value');

			if ($barkodAttr && $barkodAttr != undefined && $barkodAttr.length > 0) {
				if (variation.barkod && variation.barkod !== 'N/A') {
					$barkodAttr.html(variation.barkod);
				} else {
					const defaultValue = $barkodAttr.attr('data-attr-value');
					$barkodAttr.html(defaultValue || '');
				}
			}

			const $sifraAttr = $('.sifra-value');

			if ($sifraAttr && $sifraAttr != undefined && $sifraAttr.length > 0) {
				if (variation.sifra && variation.sifra !== 'N/A') {
					$sifraAttr.html(variation.sifra);
				} else {
					const defaultValue = $sifraAttr.attr('data-attr-value');
					$sifraAttr.html(defaultValue || '');
				}
			}

			const $kat_brAttr = $('.kataloski-broj-value');

			if ($kat_brAttr && $kat_brAttr != undefined && $kat_brAttr.length > 0) {
				if (variation.katbroj && variation.katbroj !== 'N/A') {
					$kat_brAttr.html(variation.katbroj);
				} else {
					const defaultValue = $kat_brAttr.attr('data-attr-value');
					$kat_brAttr.html(defaultValue || '');
				}
			}

			const $oblpopakAttr = $('.osnovno-pakiranje-value');

			if ($oblpopakAttr && $oblpopakAttr != undefined && $oblpopakAttr.length > 0) {
				if (variation.display_oblpopak && variation.display_oblpopak !== 'N/A') {
					$oblpopakAttr.html(variation.display_oblpopak + ' ' + variation.pakovanje);
				} else {
					const defaultValue = $oblpopakAttr.attr('data-attr-value');
					$oblpopakAttr.html(defaultValue || '');
				}
			}

			const $jamstvoAttr = $('.jamstvo-value');

			if ($jamstvoAttr && $jamstvoAttr != undefined && $jamstvoAttr.length > 0) {
				if (variation.jamstvo && variation.jamstvo !== 'N/A') {
					$jamstvoAttr.html(variation.jamstvo);
				} else {
					const defaultValue = $jamstvoAttr.attr('data-attr-value');
					$jamstvoAttr.html(defaultValue || '');
				}
			}
		}

		updateDocs(variation) {
			if (!variation?.var_docs) {
				$('[data-document-id]').attr('aria-hidden', true);
				return;
			}

			let dokumenti;
			try {
				dokumenti = JSON.parse(variation.var_docs);
			} catch (e) {
				console.error('Invalid JSON in var_docs:', e);
				$('[data-document-id]').attr('aria-hidden', true);
				return;
			}

			const docIds = Array.isArray(dokumenti) ? dokumenti.map((doc) => doc?.id).filter(Boolean) : [];

			$('[data-document-id]')
				.attr('aria-hidden', true)
				.filter(`[data-document-id="${docIds.join('"],[data-document-id="')}"]`)
				.attr('aria-hidden', false);

			const hasDocs = $('[data-document-id]').filter((i, el) => $(el).attr('aria-hidden') !== 'true').length > 0;
			const hasParentDocElements = $('[data-parent-doc]').length > 0;
			$('[data-document-id]')
				.closest('#summary-documents')
				.attr('aria-hidden', !hasDocs && !hasParentDocElements);
		}

		updateRelatedProducts(variation) {
			const ajaxData = {
				action: 'get_variation_related_products',
				nonce: w4d_frontend_ajax.nonce,
				related_ids: Array.isArray(variation.vezani_artikli) ? JSON.stringify(variation.vezani_artikli) : variation.vezani_artikli,
				variation_id: variation.variation_id,
			};
			const $carouselWrapper = $('#w4d-related-products-section');
			const $defaultSection = $('.offering-carousel-wrapper');
			const $sandboxContainer = $('#w4d-variation-carousel-wrapper');
			$sandboxContainer.find('.w4d-cached-variation-wrapper').hide();

			if (!variation.vezani_artikli || variation.vezani_artikli.length === 0 || variation.vezani_artikli === '[]') {
				$sandboxContainer.hide();
				$defaultSection.show();
				return;
			}

			$defaultSection.hide();

			const $existingCacheContainer = $sandboxContainer.find(
				`.w4d-cached-variation-wrapper[data-variation-key="${variation.variation_id}"]`
			);

			//  SHOW CACHED VARIATION SLIDER
			if ($existingCacheContainer.length > 0) {
				$sandboxContainer.show();
				$existingCacheContainer.show();
				return;
			}

			if (this.relatedProductsXHR) {
				this.relatedProductsXHR.abort();
			}

			//  FETCH NEW VARIATION SLIDER AJAX
			this.relatedProductsXHR = $.get({
				url: w4d_frontend_ajax.ajax_url,
				data: ajaxData,
				beforeSend: () => {
					$carouselWrapper.addClass('is-loading').show();
				},
				success: (response) => {
					if (response.success && response.data.trim() !== '') {
						const $newVariationElement = $(
							`<div class="w4d-cached-variation-wrapper" data-variation-key="${variation.variation_id}"></div>`
						).html(response.data);

						$sandboxContainer.append($newVariationElement);
						$sandboxContainer.show();
						$newVariationElement.show();

						// The carousel itself is a Swiper Element: it sets itself up as soon as it is in the DOM
						if (window.W4D_CarouselInstance) {
							window.W4D_CarouselInstance.init();
						}

						if (window.W4D_ShopCategories) {
							window.W4D_ShopCategories.reinit($newVariationElement);
						}
					} else {
						// Fallback default slider
						$sandboxContainer.hide();
						$defaultSection.show();
					}
				},
				error: (error) => {
					if (error.statusText === 'abort') return; // Ignore aborted request errors
					console.error('Error handling cached variation carousel strategy:', error);
					$sandboxContainer.removeClass('load').hide();
					$defaultSection.show();
				},

				complete: () => {
					setTimeout(function () {
						$carouselWrapper.removeClass('is-loading');
					}, 150);
				},
			});
		}

		prepareShareCartUrl() {
			const $dialog = $('#toggle-share-cart-dialog, .share-cart-dialog');
			const ajaxData = {
				action: 'w4d_share_cart',
				nonce: w4d_frontend_ajax.nonce,
			};

			$.post({
				url: w4d_frontend_ajax.ajax_url,
				data: ajaxData,
				beforeSend: () => {
					$dialog.addClass('is-loading');
				},
				success: (response) => {
					if (response.success) {
						const shareUrl = response.data.share_url;
						$('#share-cart-dialog-input').val(shareUrl).attr('value', shareUrl);
						$('#share-cart-copy-btn').data('carturl', shareUrl).attr('data-carturl', shareUrl);
					}
				},
				complete: () => {
					$dialog.removeClass('is-loading');
				},
				error: (xhr, status, error) => {
					let message = xhr.responseJSON?.data?.message ?? status + ' ' + error;
					W4D_Toast.showToast('error', message);
					console.error(xhr.responseJSON);
				},
			});
		}

		copyShareCartUrl(e) {
			const button = $(e.currentTarget);

			if (button.prop('disabled')) return;

			const cartUrl = button.data('carturl') || button.attr('data-carturl') || $('#share-cart-dialog-input').val();

			if (!cartUrl) {
				W4D_Toast.showToast('info', 'Poveznica se generira, molimo pričekajte.');
				return;
			}

			const updateButtonState = () => {
				const originalHtml = button.html();
				const $icon = button.find(ICON_SELECTOR).first();

				button.prop('disabled', true);
				button.addClass('btn--action');

				if ($icon.length) {
					const $checkIcon = $icon.clone();
					swapIcon($checkIcon, 'check');
					button.empty().append($checkIcon).append(' Kopirano');
				} else {
					button.text('Kopirano');
				}

				setTimeout(() => {
					button.html(originalHtml);
					button.removeClass('btn--action');
					button.prop('disabled', false);
				}, 1250);
			};

			if (navigator.clipboard && navigator.clipboard.writeText) {
				navigator.clipboard
					.writeText(cartUrl)
					.then(() => {
						W4D_Toast.showToast('success', 'Kopirano u predmemoriju');
						updateButtonState();
					})
					.catch((err) => {
						W4D_Toast.showToast('error', 'Greška prilikom kopiranja');
						console.error(err);
					});
			} else {
				const input = document.getElementById('share-cart-dialog-input');
				if (input) {
					const wasDisabled = input.disabled;
					if (wasDisabled) {
						input.removeAttribute('disabled');
					}
					input.select();
					input.setSelectionRange(0, 99999);

					try {
						const success = document.execCommand('copy');
						if (success) {
							W4D_Toast.showToast('success', 'Kopirano u predmemoriju');
							updateButtonState();
						} else {
							W4D_Toast.showToast('error', 'Greška prilikom kopiranja');
						}
					} catch (err) {
						W4D_Toast.showToast('error', 'Greška prilikom kopiranja');
						console.error(err);
					} finally {
						if (wasDisabled) {
							input.setAttribute('disabled', 'disabled');
						}
					}
				}
			}
		}
	}

	$(document).ready(() => {
		window.W4D_Cart = new W4D_Cart();
	});
})(jQuery);
